<template>
  <div id="contenedor-main-listado-adjudicaciones">
    <template v-if="cargando && !$vuetify.breakpoint.mobile">
      <v-card flat>
        <v-card-text class="pa-0">
          <v-skeleton-loader
            type="table-heading, table-thead, table-row-divider@6"
            boilerplate></v-skeleton-loader>
        </v-card-text>
      </v-card>
    </template>
    <template v-else-if="!$vuetify.breakpoint.mobile">
      <desktop
        :listadoAdjudicacionesDirectas="listadoAdjudicacionesDirectas"
        :cargando="cargando"></desktop>
    </template>
    <template v-else-if="cargando">
      <v-row>
        <v-col
          v-for="item in 4"
          :key="item"
          cols="12">
          <v-card flat>
            <v-card-text class="pa-4">
              <v-skeleton-loader
                type="heading, text, actions"
                boilerplate></v-skeleton-loader>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </template>
    <template v-else>
      <mobile :listadoAdjudicacionesDirectas="listadoAdjudicacionesDirectas"></mobile>
    </template>

    <v-card v-if="!cargando" flat class="mt-4">
      <v-card-text class="d-flex align-center justify-space-between flex-wrap pa-0">
        <div class="d-flex align-center mr-4 mb-2 mb-sm-0">
          <span class="body-2 mr-3">Registros por pagina</span>
          <v-select
            :value="paginacion.limite"
            :items="opcionesLimite"
            dense
            outlined
            hide-details
            style="max-width: 100px"
            @change="$emit('cambiar-limite', $event)"></v-select>
        </div>
        <div class="text-caption grey--text mr-4 mb-2 mb-sm-0">
          Pagina {{ paginacion.pagina }} de {{ paginacion.totalPaginas }}
          ({{ paginacion.total }} registros)
        </div>
        <v-pagination
          :value="paginacion.pagina"
          :length="Math.max(paginacion.totalPaginas, 1)"
          :total-visible="7"
          @input="$emit('cambiar-pagina', $event)"></v-pagination>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import Desktop from './Desktop.vue';
import Mobile from './Mobile.vue';

export default {
  name: 'MainListadoAdjudicaciones',
  props: {
    listadoAdjudicacionesDirectas: {
      type: Array,
      required: true,
    },
    cargando: {
      type: Boolean,
      default: false,
    },
    paginacion: {
      type: Object,
      required: true,
    },
  },
  components: {
    Desktop,
    Mobile,
  },
  data() {
    return {
      opcionesLimite: [10, 20, 50, 100],
    };
  },
};
</script>

<style lang="scss">

</style>
